const productCategory = [
  // Main categories
  { id: 1, label: 'Gift Cards', value: 'gift cards' },
  { id: 2, label: 'Prepaid Cards', value: 'prepaid cards' },
  { id: 3, label: 'Crypto/Online', value: 'crypto online' },
];

export default productCategory;
